<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>请假管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="员工" prop="userid">
          <el-select v-model="query.accID" placeholder="请选择" filterable clearable @change="selList()">
            <el-option v-for="item in userList" :label="item.realName" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker v-model="query.daterange" @change="selList()" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>

        </el-form-item>
      </el-form>

      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>请假列表</span>
        </div>
        <!-- 状态 -->
        <el-tabs v-model="query.state" @tab-click="selList()">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane :label="item.name" :key="item.id" :name="item.id.toString()"
            v-for="item in statelist"></el-tab-pane>
        </el-tabs>
        <!-- 列表定义 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width: 100%">
          <el-table-column label="微信头像">
            <template slot-scope="scope">
              <el-image style="width: 40px; border-radius: 50%;" :src="scope.row.account.photo"> </el-image>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="account.nickName" label="微信昵称"></el-table-column> -->
          <el-table-column prop="account.realName" label="员工姓名"></el-table-column>
          <el-table-column prop="realName" label="填写名称"></el-table-column>
          <el-table-column prop="company.fullName" label="公司名称"></el-table-column>
          <el-table-column prop="clockTypeName" label="请假类型"></el-table-column>
          <el-table-column prop="dayCount" label="天数"></el-table-column>
          <el-table-column prop="askStateName" label="状态"></el-table-column>
          <el-table-column prop="startTime" label="提交时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <el-button type="warning" size="mini" icon="el-icon-delete" @click="delClick(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>
    <!-- 操作对话框 -->
    <el-dialog title="请假审核" :visible.sync="dialogVisible">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <el-row :gutter="24" v-if="form.account">
          <el-col :span="12">
            <el-form-item label="头像">
              <el-image style="width: 40px; border-radius: 50%;" :src="form.account.photo"> </el-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="填写姓名"> {{ form.realName }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="请假类型">
              {{ form.clockTypeName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              {{ form.askStateName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="请假天数">
              {{ form.dayCount }}天
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="请假开始时间">{{ form.startTime }}</el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="请假结束时间">{{ form.endTime }}</el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="请假原因">
          {{ form.reason }}
        </el-form-item>
        <el-form-item label="备注说明">
          <el-input v-model="form.handleSummary" placeholder="请填写审核备注"
            :disabled="form.state != 1 ? true : false"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="form.state == 1" type="primary" :loading="submiting" @click="submitForm(2)">通过</el-button>
          <el-button v-if="form.state == 1" type="danger" :loading="submiting" @click="submitForm(3)">驳回</el-button>
          <el-button v-if="form.state == 1" type="warning" :loading="submiting" @click="submitForm(4)">调休</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
export default {
  data() {
    return {
      key: "",
      query: {
        state: null
      }, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
      userList: [], //员工列表
      typeList: [], //类型列表
      isAdmin: user.isAdmin(),
      statelist: [],//状态列表
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    //查询列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (params.daterange) {
        params.startTime = params.daterange[0];
        params.endTime = params.daterange[1];
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getAtt("GetList");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    parent: function () {
      var _this = this;
      //获取类型
      var link = url.getAtt("GetAskType");
      $.get(link, {}, (data) => {
        // console.log(data);
        _this.statelist = data.statelist;
      });
      //获取员工
      link = url.getUser("getemployee");
      $.get(link, {}, (data) => {
        _this.userList = data;
      });

    },
    //提交表单
    submitForm(state) {
      var _this = this;
      var link = url.getAtt("save_Ask");
      var info = this.form;
      var userinfo = user.getInfo();
      info.HanldeID = userinfo.id;
      info.state = state;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              if (state == 3) {
                _this.$message({
                  type: "success",
                  message: "已驳回",
                });
              }else{
                _this.$message({
                  type: "success",
                  message: "已通过",
                });
              }

            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function (row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getAtt("delete_Ask"); //获取请求地址
      var ID = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { ID }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //自动计算处理
    calSecureAmount: function () {
      var form = this.form;
      if (form) {
        form.secureAmount = (form.sbAmount || 0) + (form.ybAmount || 0);
      }
      this.calRealAmount();
    },
    calRealAmount() {
      var form = this.form;
      if (form) {
        form.realAmount =
          (form.sendAmount || 0)
          + (form.secureAmount || 0)
          + (form.houseAmount || 0)
          + (form.developAmount || 0)
          ;
      }
    },
    calSendAmount() {
      var form = this.form;
      if (form) {
        form.sendAmount = (form.sendBase || 0) + (form.sendJX || 0);
      }
    },
  },
  mounted() {
    //获取服务器列表
    this.getList();
    //获取父类菜单
    this.parent();
  },
};
</script>
